import ENV from '@/config/environment';
import { events } from '@/config/events';

export const ATTRIBUTION_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];

// Every dataLayer push goes through here. Outside production the complete object is logged under a
// greppable prefix, mirroring Ember's enable_qa_output / "CJ Testing Output" convention (PAE-2465).
const push = (obj) => {
  if(ENV.enableQaOutput) {
    // Intentional QA output outside production (PAE-2465).
// eslint-disable-next-line no-console
    console.log('%cTB Tracking Output: dataLayer push >>', 'color: white; background-color: #fcb900;', obj);
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(obj);
};

export const track = (eventName) => {
  //GTM track
  const GTMEventObj = events.GTM[eventName];
  push(createPayload(GTMEventObj));
};

// Registration conversion (contract §1). Fired once per created account, never on login.
// Carries no value or currency by decision.
export const trackRegistration = ({ method, eventId, attribution = {} }) => {
  const payload = {
    event: 'registration',
    event_id: eventId,
    signup_method: method
  };
  ATTRIBUTION_KEYS.forEach((key) => {
    if(attribution[key] !== undefined && attribution[key] !== null && attribution[key] !== '') {
      payload[key] = attribution[key];
    }
  });
  push(payload);
};

const createPayload = (eventData = {}) => {
  const defaultPayload = {
    event: 'trackEvent',
    eventCategory: '',
    eventAction: '',
    eventLabel: '',
    eventValue: ''
  };
  const payload = {
    ...defaultPayload,
    ...eventData,
  };

  return payload;
};
